import { userConstants } from './../constants/user.constants';

const initialState = {};

export function createApplication(state = initialState, action) {
   switch (action.type) {
    case userConstants.CREATE_APPLICATION_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.CREATE_APPLICATION_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.CREATE_APPLICATION_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }

}
